import { useState, useEffect } from 'react';
import AdminLayout from '../components/AdminLayout';
import StatsCard from '../components/StatsCard';
import { useAuth } from '../context/AuthContext';
import API from '../api';

function AdminDashboard() {
  const { userInfo } = useAuth();
  const [stats, setStats] = useState({
    clients: 0,
    projects: 0,
    files: 0,
    invoices: 0
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { data: clients } = await API.get('/clients');
        const { data: projects } = await API.get('/projects');
        const { data: invoices } = await API.get('/invoices');
        setStats({
          clients: clients.length,
          projects: projects.length,
          files: 0,
          invoices: invoices.length
        });
      } catch (error) {
        console.error('Error fetching stats');
      }
    };
    fetchStats();
  }, []);

  return (
    <AdminLayout>
      <div style={styles.header}>
        <div>
          <h1 style={styles.heading}>Dashboard</h1>
          <p style={styles.subheading}>Welcome back, {userInfo?.name}! 👋</p>
        </div>
        <div style={styles.date}>
          {new Date().toLocaleDateString('en-US', {
            weekday: 'long', year: 'numeric',
            month: 'long', day: 'numeric'
          })}
        </div>
      </div>

      <div style={styles.statsGrid}>
        <StatsCard title="Total Clients" value={stats.clients} icon="👥" color="#4f46e5" />
        <StatsCard title="Active Projects" value={stats.projects} icon="📁" color="#10b981" />
        <StatsCard title="Files Shared" value={stats.files} icon="📎" color="#f59e0b" />
        <StatsCard title="Invoices" value={stats.invoices} icon="💰" color="#ef4444" />
      </div>

      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Recent Activity</h2>
        <div style={styles.activityBox}>
          <div style={styles.activityItem}>
            <span style={styles.activityDot('green')}></span>
            <p style={styles.activityText}>System is ready. Start by adding your first client!</p>
          </div>
        </div>
      </div>

      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Quick Actions</h2>
        <div style={styles.actionsGrid}>
          <button style={{ ...styles.actionBtn, backgroundColor: '#4f46e5' }}>➕ Add New Client</button>
          <button style={{ ...styles.actionBtn, backgroundColor: '#10b981' }}>📁 Create Project</button>
          <button style={{ ...styles.actionBtn, backgroundColor: '#f59e0b' }}>💰 Create Invoice</button>
          <button style={{ ...styles.actionBtn, backgroundColor: '#8b5cf6' }}>💬 Send Message</button>
        </div>
      </div>
    </AdminLayout>
  );
}

const styles = {header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', flexWrap: 'wrap', gap: '10px' },  heading: { margin: '0', fontSize: '28px', fontWeight: '700', color: '#1a1a2e' },
  subheading: { margin: '4px 0 0 0', color: '#718096', fontSize: '15px' },
  date: { color: '#718096', fontSize: '14px' }, statsGrid: { display: 'flex', gap: '20px', marginBottom: '30px', flexWrap: 'wrap' },
  section: { backgroundColor: 'white', borderRadius: '12px', padding: '24px', marginBottom: '24px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)' },
  sectionTitle: { margin: '0 0 16px 0', fontSize: '18px', fontWeight: '600', color: '#1a1a2e' },
  activityBox: { display: 'flex', flexDirection: 'column', gap: '12px' },
  activityItem: { display: 'flex', alignItems: 'center', gap: '12px' },
  activityDot: (color) => ({ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: color, flexShrink: 0 }),
  activityText: { margin: '0', color: '#4a5568', fontSize: '14px' },
  actionsGrid: { display: 'flex', gap: '12px', flexWrap: 'wrap' },
  actionBtn: { padding: '12px 20px', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }
};

export default AdminDashboard;